export const chatbot = {
   p1: `Virtuellen Assistenten einrichten`,
   p2: `Aktivieren Sie den Chatbot-Service, um die häufigsten Fragen Ihrer Gäste automatisch zu beantworten.`,
   p3: `Richten Sie Ihren virtuellen Assistenten ein. Passen Sie die Antworten Ihres Chatbots an, um Ihren Gästen schnelle und präzise Informationen zu geben. Lösen Sie ihre häufigsten Anliegen automatisch.`,
   p4: `Konfigurieren`,
   p5: `Virtueller Assistent erfolgreich aktiviert`,
   p6: `Virtueller Assistent deaktiviert`,

   p7: `ChatBot-Antworten einrichten`,
   p8: `Zugewiesene Unterkunft:`,
   p9: `Passen Sie die automatischen Antworten des Chatbots an, um die häufigsten Fragen Ihrer Gäste effizient zu beantworten.`,

   p10: `Sie haben nicht gespeicherte Änderungen. Möchten Sie sie verwerfen und die Frage wechseln?`,

   p11: `Frage:`,
   p12: `Bild in die Antwort einfügen`,
   p13: `Bild hochladen`,
   p14: `Bild löschen`,
   p15: `Antwort speichern`,
   p16: `Antwort erfolgreich gespeichert`,
   p17: `Beim Speichern der Antwort ist ein Fehler aufgetreten.`,

   p18: `Beim Löschen des Bildes ist ein Fehler aufgetreten.`,
   p19: `Schreiben Sie Ihre Antwort …`,

   p20: `Antwortblock`,
   p21: `Vorschau`,
   p22: ``,
   p23: ``,
   p24: ``,
   p25: ``,
   p26: ``,
   p27: ``,
   p28: ``,
   p29: ``,
   p30: ``,
}
